import { React } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import "../../css/landing.scss";

const Landing = ({ details }) => {
  document.title = "Queer in Color";
  return (
    <section id="home">
      <p id="from">from the editor...</p>
      <p id="description">{details.credit}</p>
      <p><Link id="editorial-link" to="/editorial">{details.link} &#x2197;</Link></p>
    </section>
  )
};

Landing.propTypes = {
  details: PropTypes.shape({
    supertitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    credit: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired
  })
}

Landing.defaultProps = {
  details: undefined
}

export default Landing;
